import { 
    Monitor, 
    Smartphone, 
    Watch, 
    Database, 
    RotateCcw, 
    Accessibility, 
    Globe, 
    Shield, 
    Cpu, 
    BarChart3, 
    Gauge, 
    FileText, 
    Settings,
    CheckCircle,
    Users,
    Target,
  } from "lucide-react";
  import { ServiceData, ServiceLabel, ServiceCategory } from '@/types/services';
  
  export const services: ServiceData[] = [
    {
      id: "web-desktop-testing",
      title: "services.webDesktop.title",
      description: "services.webDesktop.description",
      icon: Monitor,
      color: "text-nexus-teal",
      bgColor: "bg-nexus-teal/10",
      labels: [ServiceLabel.BASIC, ServiceLabel.ADVANCED],
      category: ServiceCategory.COMPREHENSIVE
    },
    {
      id: "mobile-apps-testing",
      title: "services.mobileApps.title",
      description: "services.mobileApps.description",
      icon: Smartphone,
      color: "text-nexus-red",
      bgColor: "bg-nexus-red/10",
      labels: [ServiceLabel.BASIC, ServiceLabel.ADVANCED],
      category: ServiceCategory.COMPREHENSIVE
    },
    {
      id: "wearable-apps-testing",
      title: "services.wearableApps.title",
      description: "services.wearableApps.description",
      icon: Watch,
      color: "text-purple-600",
      bgColor: "bg-purple-100",
      labels: [ServiceLabel.BASIC],
      category: ServiceCategory.COMPREHENSIVE
    },
    {
      id: "api-testing",
      title: "services.apiTesting.title",
      description: "services.apiTesting.description",
      icon: Database,
      color: "text-blue-600",
      bgColor: "bg-blue-100",
      labels: [ServiceLabel.BASIC, ServiceLabel.ADVANCED],
      category: ServiceCategory.COMPREHENSIVE
    },
    {
      id: "regression-testing",
      title: "services.regressionTesting.title",
      description: "services.regressionTesting.description",
      icon: RotateCcw,
      color: "text-green-600",
      bgColor: "bg-green-100",
      labels: [ServiceLabel.BASIC, ServiceLabel.ADVANCED],
      category: ServiceCategory.COMPREHENSIVE
    },
    {
      id: "accessibility-testing",
      title: "services.accessibilityTesting.title",
      description: "services.accessibilityTesting.description",
      icon: Accessibility,
      color: "text-nexus-yellow",
      bgColor: "bg-nexus-yellow/10",
      labels: [ServiceLabel.BASIC, ServiceLabel.ADVANCED],
      category: ServiceCategory.COMPREHENSIVE
    },
    {
      id: "localization-testing",
      title: "services.localizationTesting.title",
      description: "services.localizationTesting.description",
      icon: Globe,
      color: "text-indigo-600",
      bgColor: "bg-indigo-100",
      labels: [ServiceLabel.BASIC, ServiceLabel.ADVANCED],
      category: ServiceCategory.COMPREHENSIVE
    },
    {
      id: "database-testing",
      title: "services.databaseTesting.title",
      description: "services.databaseTesting.description",
      icon: Database,
      color: "text-nexus-teal",
      bgColor: "bg-nexus-teal/10",
      labels: [ServiceLabel.BASIC, ServiceLabel.ADVANCED],
      category: ServiceCategory.COMPREHENSIVE
    },
    {
      id: "security-testing",
      title: "services.securityTesting.title",
      description: "services.securityTesting.description",
      icon: Shield,
      color: "text-red-600",
      bgColor: "bg-red-100",
      labels: [ServiceLabel.BASIC, ServiceLabel.ADVANCED],
      category: ServiceCategory.COMPREHENSIVE
    },
    {
      id: "iot-testing",
      title: "services.iotTesting.title",
      description: "services.iotTesting.description",
      icon: Cpu,
      color: "text-orange-600",
      bgColor: "bg-orange-100",
      labels: [ServiceLabel.BASIC, ServiceLabel.ADVANCED],
      category: ServiceCategory.COMPREHENSIVE
    },
    {
      id: "big-data-testing",
      title: "services.bigDataTesting.title",
      description: "services.bigDataTesting.description",
      icon: BarChart3,
      color: "text-cyan-600",
      bgColor: "bg-cyan-100",
      labels: [ServiceLabel.BASIC, ServiceLabel.ADVANCED],
      category: ServiceCategory.COMPREHENSIVE
    },
    {
      id: "performance-testing",
      title: "services.performanceTesting.title",
      description: "services.performanceTesting.description",
      icon: Gauge,
      color: "text-nexus-yellow",
      bgColor: "bg-nexus-yellow/10",
      labels: [ServiceLabel.BASIC, ServiceLabel.ADVANCED],
      category: ServiceCategory.COMPREHENSIVE
    },
    {
      id: "test-strategy-design",
      title: "services.testStrategyDesign.title",
      description: "services.testStrategyDesign.description",
      icon: FileText,
      color: "text-nexus-red",
      bgColor: "bg-nexus-red/10",
      labels: [ServiceLabel.BASIC, ServiceLabel.ADVANCED],
      category: ServiceCategory.COACHING
    },
    {
      id: "test-management-consultation",
      icon: Settings,
      title: "services.testManagementConsultation.title",
      description: "services.testManagementConsultation.description",
      color: "text-gray-600",
      bgColor: "bg-gray-100",
      labels: [ServiceLabel.ADVANCED],
      category: ServiceCategory.COACHING
    }
  ];

  export const servicesCategories = [
    {
      id: ServiceCategory.COMPREHENSIVE,
      title: "services_categories.comprehensiveTesting.title",
      subtitle: "services_categories.comprehensiveTesting.subtitle",
      description: "services_categories.comprehensiveTesting.description",
      icon: CheckCircle,
      color: "text-nexus-teal",
      bgColor: "bg-nexus-teal/10",
    },
    {
      id: ServiceCategory.COACHING,
      title: "services_categories.coachingServices.title",
      subtitle: "services_categories.coachingServices.subtitle",
      description: "services_categories.coachingServices.description",
      icon: Users,
      color: "text-nexus-red",
      bgColor: "bg-nexus-red/10",
    },
     {
      id: ServiceCategory.CROWDTESTING,
      title: "services_categories.crowdTesting.title",
      subtitle: "services_categories.crowdTesting.subtitle",
      description: "services_categories.crowdTesting.description",
      icon: Target,
      color: "text-nexus-yellow",
      bgColor: "bg-nexus-yellow/10",
    },
  ]
  
  export const getServiceById = (id: string): ServiceData | undefined => {
    return services.find(service => service.id === id);
  };